import styled from '@emotion/styled';

export const SidebarFilterWrapper = styled.div`
  margin: 0 11px 22px 11px;

  .euiToolTipAnchor {
    width: 100%;
  }

  .euiFormLabel {
    font-size: 14px;
    color: ${({ theme }): string => theme.GREY_7};
    font-weight: 500;
    margin-bottom: 4px;
  }

  .euiFormControlLayout {
    border: 1px solid ${({ theme }): string => theme.GREY_3};
    border-radius: 4px;
  }

  .euiFormControlLayout * {
    background: none;
    box-shadow: none;
  }

  .euiFormControlLayoutClearButton {
    background: ${({ theme }): string => theme.GREY_5};
  }
`;
export const SidebarFilterCodeSearch = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: ${({ theme }): string => theme.GREY_6};
  margin-top: 4px;
  line-height: 1.5;

  button {
    width: 100%;
    text-decoration: none;
    text-transform: uppercase;
    background-color: ${({ theme }): string => theme.PRIMARY};
    color: ${({ theme }): string => theme.WHITE};
    border: none;
    letter-spacing: 1px;
  }

  button:disabled {
    color: ${({ theme }): string => theme.GREY_6};
    background-color: ${({ theme }): string => theme.GREY_2};
    cursor: not-allowed;
    &:hover {
      text-decoration: none;
    }
  }
`;
